import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

function getSessionId() {
  let sid = localStorage.getItem("pph_session_id");
  if (!sid) {
    sid =
      (crypto.randomUUID && crypto.randomUUID()) ||
      `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("pph_session_id", sid);
  }
  return sid;
}

/**
 * Fire-and-forget page-view tracker. Skips admin routes so the owner's own
 * navigation doesn't pollute the site-visitors metric.
 */
export default function useVisitTracker() {
  const { pathname } = useLocation();
  const last = useRef(null);

  useEffect(() => {
    if (pathname === last.current) return;
    last.current = pathname;
    if (pathname.startsWith("/admin")) return;
    const sid = getSessionId();
    api
      .post("/track", {
        path: pathname,
        session_id: sid,
        referrer: document.referrer || null,
      })
      .catch(() => {
        /* silent */
      });
  }, [pathname]);
}
